<mat-card-content>
  <div class="w-75 center-div d-flex justify-content-center mt-4">
    <ng-container [ngSwitch]="data?.type">
      <ng-container *ngSwitchCase="'success'">
        <mat-icon class="icon-check" svgIcon="done"></mat-icon>
      </ng-container>
      <ng-container *ngSwitchCase="'warning'">
        <mat-icon class="icon-danger" svgIcon="warning"></mat-icon>
      </ng-container>
      <ng-container *ngSwitchCase="'info'">
        <mat-icon svgIcon="question"></mat-icon>
      </ng-container>
      <ng-container *ngSwitchCase="'danger'">
        <mat-icon class="icon-danger" svgIcon="cancel"></mat-icon>
      </ng-container>
    </ng-container>
  </div>
  <div class="w-75 center-div">
    <p class="text-center" *ngIf="data?.result">{{data?.result}}</p>
    <p class="text-center" [innerHTML]="data.text"></p>
  </div>
  <ng-container *ngIf="data?.list?.length > 0">
    <div class="mt-3 mb-3">
      <app-modal-small-table [DATA]="data?.list" [COLUMNS]="data?.columns"> </app-modal-small-table>
    </div>
  </ng-container>
  <div class="row justify-content-md-center mb-3">
    <div class="col-md-4" *ngIf="data?.modalconfirm">
      <button id="modalSmallCancel" mat-stroked-button class="button-primary-event border-box w-100" mat-dialog-close *ngIf="data?.modalconfirm">
        {{ data?.btnCancel }}
      </button>
    </div>
    <div class="col-md-4">
      <button id="modalSmallAccept" mat-flat-button class="button-primary-event border-box w-100 button-success" mat-dialog-close="true">
        {{ data?.btnAccept }}
      </button>
    </div>
  </div>
</mat-card-content>
<button mat-button mat-dialog-close class="dialog-close">
  <mat-icon>close</mat-icon>
</button>
